import { deskForRole, productLabel } from "../../js/auth/packageAccess";
import { useAuth } from "../../js/hooks/useAuth";

const DESK_LABELS = {
  buyer: "Buyer Journey",
  seller: "Seller Journey",
  agent: "Agent Console",
  broker: "Broker Office",
  admin: "Admin Desk",
};

export default function DeskPlatformBadge() {
  const { session } = useAuth();
  if (!session?.role || session.role === "admin") return null;

  const desk = deskForRole(session.role);
  const deskLabel = DESK_LABELS[desk] || "Desk";

  return (
    <p className="desk-platform-badge" data-tour="desk-platform-badge">
      <span className="desk-platform-badge__desk">{deskLabel}</span>
      <span className="desk-platform-badge__sep" aria-hidden="true">
        ·
      </span>
      <span className="desk-platform-badge__plan">{productLabel(session)}</span>
    </p>
  );
}
